import { featuredProducts } from '../../../mocks/products';

const ProductsSection = () => {
  return (
    <section id="productos" className="py-24 bg-[#1a1a1a]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 border border-[#D4AF37] rounded-full mb-6">
            <span className="text-[#D4AF37] text-sm font-light">Distribuidores Autorizados</span>
          </div>
          <h2 className="font-['Playfair_Display'] text-5xl lg:text-6xl font-bold text-white mb-6">
            Skincare de Alta Calidad<br />Distribución Autorizada en Costa Rica
          </h2>
          <p className="text-gray-400 text-lg font-light max-w-2xl mx-auto">
            Especializados en La Roche-Posay y las mejores marcas internacionales de cuidado de la piel
          </p>
        </div>

        {/* Mobile: 2-column category grid */}
        <div className="grid grid-cols-2 gap-3 md:hidden" data-product-shop>
          {featuredProducts.map((product) => (
            <div
              key={product.id}
              className="bg-[#f2f2f0] rounded-2xl overflow-hidden cursor-pointer active:scale-95 transition-all duration-200"
            >
              <div className="w-full aspect-square flex items-center justify-center p-4 bg-[#f2f2f0]">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain object-center"
                />
              </div>
              <div className="px-3 pb-4 pt-1 bg-[#f2f2f0]">
                <p className="text-[#1a1a1a] text-xs font-bold tracking-widest uppercase text-center leading-tight">
                  {product.name}
                </p>
                <p className="text-gray-500 text-[10px] text-center mt-1 uppercase tracking-wider">
                  {product.category}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Desktop: 3-column full card grid */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {featuredProducts.map((product) => (
            <div
              key={product.id}
              className="rounded-3xl overflow-hidden hover:scale-105 transition-all duration-300 cursor-pointer shadow-lg"
            >
              <div
                className="w-full h-64 overflow-hidden relative"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=luxurious%20white%20marble%20texture%20with%20soft%20grey%20veins%2C%20elegant%20polished%20stone%20surface%2C%20high%20end%20interior%20material%2C%20clean%20minimal%20background%2C%20smooth%20marble%20slab%20with%20subtle%20golden%20veins%2C%20premium%20quality%20stone%20texture%2C%20bright%20white%20base%20with%20delicate%20grey%20and%20gold%20streaks&width=600&height=400&seq=marble-bg-001&orientation=landscape')`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6 bg-[#1a1a1a]">
                <p className="text-[#D4AF37] text-xs font-semibold tracking-wider uppercase mb-1">{product.brand}</p>
                <h3 className="text-white text-lg font-semibold mb-1">{product.name}</h3>
                <p className="text-gray-400 text-xs mb-3">{product.category}</p>
                <p className="text-gray-300 text-sm font-light leading-relaxed mb-4">{product.description}</p>
                <div className="flex items-center space-x-2">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-shield-check-fill text-[#D4AF37] text-base"></i>
                  </div>
                  <span className="text-gray-400 text-xs">{product.certType}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <p className="text-gray-400 text-sm font-light">
            ¿Buscás un producto específico?{' '}
            <button
              onClick={() => document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' })}
              className="text-[#D4AF37] underline cursor-pointer whitespace-nowrap"
            >
              Consultanos
            </button>{' '}
            y lo conseguimos para vos.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
